import classnames from 'classnames';
import React, { ReactNode } from 'react';

type Props = {
  message: ReactNode;
  secondary?: ReactNode;
  className?: string;
};

export const NoData = ({ message, secondary, className }: Props) => (
  <div className={classnames(className)}>
    <div className="py-4 text-center">
      <div className="font-semibold text-primary">{message}</div>
      <div className="text-sm text-neutral">{secondary}</div>
    </div>
  </div>
);

NoData.defaultProps = {
  message: 'There is nothing to show',
  secondary: '',
};
